import AXIOS from '@/utils/$axios';
// 首页优秀设计风格字典
export const getDesignStyle = params =>
    AXIOS.get('/hdc-admin/cms/design/form', { params });

// 优秀设计列表
export const getDesignList = params =>
    AXIOS.get('/hdc-admin/cms/auth/design/list', { params });

// 筛选条件类型列表-APP
export const getDesignDictListApp = params =>
    AXIOS.get('/hdc-admin/cms/dict/list-app', { params });

// 优秀设计详情
export const getDesignDetail = id =>
    AXIOS.get(`/hdc-admin/cms/auth/design/info/${id}`);

// 设计banner
export const cmsBannerList = params =>
    AXIOS('/hdc-admin/cms/design/home', { params });

// 城市列表
export const getCityList = params =>
    AXIOS('/lws/common/get-all-city', { params });

// 历史搜索
export const getHistory = params =>
    AXIOS('/hdc-admin/cms/auth/design/search/list', { params });

// 清空历史搜索
export const deleteHistory = () =>
    AXIOS.delete('/hdc-admin/cms/auth/design/search/delete');

// 收藏管理
export const effectCollect = payload =>
    AXIOS.post('/hdc-admin/cms/auth/design/collect', payload);

// 设计分享信息
export const queryDesign = payload =>
    AXIOS.post('/lws/house/get-promot-share', payload, {
        cancelWarn({ code }) {
            return 13002 === code;
        },
    });

// 优秀设计推介
export const getHomeDesign = params =>
    AXIOS.get('/hdc-admin/cms/auth/design/home', { params });

export const getMyDesign = params =>
    AXIOS.post('/hdc-admin/cms/auth/design/submit-list', params);

export const submitDesign = data =>
    AXIOS.post('/hdc-admin/cms/auth/design/submit', data);
export const deleteContribute = payload =>
    AXIOS({
        url: '/hdc-admin/cms/auth/design/delete',
        method: 'delete',
        data: payload,
        headers: { 'Content-Type': 'application/json' },
    });

// 查询导出3D方案刘表
export const getExportList = payload =>
    AXIOS.post('/space/collection/get-scheme-list', payload);

// 免费设计申请
export const postPostDesign = payload =>
    AXIOS.post('space/user/apply-decoration', payload);

// 查询可用的方案列表，设计方案返回有 3d 漫游的，平面图方案返回有图片的
export const querySchemeList = payload =>
    AXIOS.post('/space/collection/get-scheme-plan-list', payload);
